import React, { useState } from "react";
import { useFormikContext } from "formik";
import moment from "moment";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useMediaQuery from "@mui/material/useMediaQuery";
import { serverFormat } from "utils/dates";
import useMutation from "src/hooks/useMutation";
import useQueryParams from "src/hooks/useQueryParams";
import useNotification from "src/hooks/notification";
import { UPDATE_SHIPMENT_RECEIVED_AT_MUTATION } from "src/constants/graphql/mutations";

export default function ReceivedOnDatePicker() {
  const { values, setFieldValue } = useFormikContext();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const params = useQueryParams();
  const shipmentId = params.get("id");
  const { notifyError } = useNotification();
  const [updateReceivedAt] = useMutation(UPDATE_SHIPMENT_RECEIVED_AT_MUTATION);

  const persistReceivedAt = receivedAt => {
    if (!shipmentId) return;

    updateReceivedAt({
      variables: { id: shipmentId, input: { receivedAt } },
      onFailure: errors => {
        notifyError(errors?.submit || Object.values(errors || {})[0] || "Could not save received on date.");
      },
    });
  };

  const handleDateChange = date => {
    if (!date || !moment(date).isValid()) return;

    const receivedAt = moment(date).format("YYYY-MM-DD");
    setFieldValue("receivedAt", receivedAt);
    if (values.receivedAt && moment(values.receivedAt).format("YYYY-MM-DD") === receivedAt) return;

    persistReceivedAt(receivedAt);
  };

  if ((!values.receivedAt && !values.completeTime) || values.draft) return null;

  const displayDate = values.receivedAt || values.completeTime;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {!isMobile && <Typography>Received On:</Typography>}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label={isMobile ? "Received On" : undefined}
          value={displayDate ? moment(displayDate, serverFormat) : null}
          onChange={handleDateChange}
          format="MM/DD/YYYY"
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slotProps={{
            textField: {
              size: "small",
              onClick: () => setOpen(true),
              sx: {
                width: 150,
                "& .MuiOutlinedInput-notchedOutline": isMobile ? {} : { border: "none" },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}
